import React, {useEffect, useState} from "react";

import {ButtonContainer, LoaderContainer, override} from "@pages/reusable-components/styled-components";
import {Card, CardBody, CardHeader, Col, FormGroup, Input, Row} from "reactstrap";
import {InputKeySelect} from "@pages/components/InputSelect";
import InputCustom from "@pages/components/InputCustom";
import {validateForm} from "../../../../../constants";
import {ClipLoader} from "react-spinners";

const allowedFields = [
    'bank_name',
    'bank_sort_code',
    'bank_account_name',
    'bank_account_number',
];
export default function Finance({ initialCustomer,
                                     onSave,
                                     goList,
                                     }) {
    const [customer, setCustomer] = useState({});
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        if (initialCustomer) {
            const filtered = Object.fromEntries(
                allowedFields.map((key) => [key, initialCustomer[key] ?? ''])
            );
            setCustomer(filtered);
            setLoading(false)
        } else {
            const empty = Object.fromEntries(allowedFields.map((key) => [key, '']));
            setCustomer(empty);
        }
    }, [initialCustomer]);
    const update = (updates) => {
        setCustomer((prev) => ({
            ...prev,
            ...updates,
        }));
    };
    const handleSave = () => {
        onSave(customer);
    };

    const getValue = (key) => customer?.[key] || '';

    return (
        loading ? <LoaderContainer>
                <ClipLoader
                    css={override}
                    size={40}
                    color={`#7B61E4`}
                    loading={loading}
                />
            </LoaderContainer>
            :
        <Card>
            <CardHeader>
                <h1 className="mb-0">Financial Information</h1>
            </CardHeader>
            <CardBody>
                <Row>
                    <Col md={4} sm={12}>
                        <InputCustom
                            newLabel={'Bank name'}
                            placeholder={'Bank name'}
                            value={getValue('bank_name')}
                            onChange={(e) =>
                                update({ bank_name: e.target.value})
                            }
                        />
                        <InputCustom
                            newLabel={'Bank sort code'}
                            placeholder={'Bank sort code'}
                            value={getValue('bank_sort_code')}
                            onChange={(e) =>
                                update({ bank_sort_code: e.target.value})
                            }
                        />
                    </Col>

                    <Col md={4} sm={12}>
                        <InputCustom
                            newLabel={'Bank account name'}
                            placeholder={'Bank account name'}
                            value={getValue('bank_account_name')}
                            onChange={(e) =>
                                update({ bank_account_name: e.target.value})
                            }
                        />
                        <InputCustom
                            newLabel={'Bank account number'}
                            placeholder={'Bank account number'}
                            value={getValue('bank_account_number')}
                            onChange={(e) =>
                                update({ bank_account_number: e.target.value})
                            }
                        />
                    </Col>
                </Row>
                <div className="d-flex flex-row justify-content-end">
                    <ButtonContainer onClick={() => goList(true)}>Cancel</ButtonContainer>
                    <ButtonContainer reverse onClick={() => handleSave()}>Save</ButtonContainer>
                </div>
            </CardBody>
        </Card>
    );
}